import styled from 'styled-components';

export const HeroBanner = styled.div`
    &[id='errorBanner'] {
        border: none;
        @media (min-width: 1024px) {
            .hidden.items-center {
                margin-top: 190px;
            }
        }
        @media (max-width: 1023px) {
            background-color: #EAF0E7!important;
            > div {
                background-color: transparent!important;
                border-radius: 0;
                > div {
                    width: 100%;
                    picture {
                        width: 100%;
                        img{
                            width: 100%;
                        }
                    }
                }
            }
            p {
                color: rgba(0, 0, 0, 0.70)!important;
            }
        }
        hr {
            @media (min-width: 1024px) {
                margin-left: 0;
            }
        }

        p a{
            font-size: 16px;
            color: #165F57;
            font-weight: 700;
            text-decoration: underline;
        }
    }
`;


